import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-android-keystore-generator-info-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './android-keystore-generator-info-section.component.html',
  styleUrl: './android-keystore-generator-info-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AndroidKeystoreGeneratorInfoSectionComponent {
  protected readonly features = [
    {
      icon: '@tui.globe',
      title: 'Browser-Based',
      description:
        'Generate your keystore directly in your browser. No software installation required.',
    },
    {
      icon: '@tui.shield-check',
      title: 'Privacy-First',
      description:
        'Your private key never leaves your device. Everything runs locally using the Web Crypto API.',
    },
    {
      icon: '@tui.award',
      title: 'Industry Standard',
      description:
        'Creates PKCS#12 keystores with RSA 2048-bit keys, compatible with Google Play and all Android tools.',
    },
  ];
}
